import { lazy } from 'react';
import { ICONS } from '../navigationIcons';

const AccountsPage = lazy(() => import('src/compass/pages/midOffice/AccountsPage'));

export const MidOfficeMenu = [
  {
    menuTitle: 'Mid-Office',
    path: 'mid-office',
    icon: ICONS.user,
    subMenus: [
      {
        title: 'Accounts',
        path: 'accounts',
        element: <AccountsPage />,
        permission: 'MIDOFFICE_ACCOUNTS',
      },
    ],
  },
];
